<!-- <div  class="lin">
    </div> -->

       <!-- <input type="file" (change)="onImageSelected($event)" accept="image/*">
    <div *ngIf="imageBase64">
      <img [src]="imageBase64" alt="Selected Image"> 
      <div *ngFor="let piece of imagePieces">
        <img [src]="piece" alt="Image Piece"> 
      </div> 
    </div>-->
    <div class="col-md-12 row" style="min-width: 600px;">
      <div class="col-md-7 row" >
    <div class=" col-md-3" (click)="OnClickFlight()" style="cursor:pointer">
     <span *ngIf="!isActive('/app/hotellist')&&!isActive('/app/flightlist')&&!isActive('/app/flightList')&&!isActive('/app/flight-intl-list')">
        <img *ngIf="!isActive('/app/flight')"[src]="imagePieces[0]" width="45" height="45" alt="">
        <img *ngIf="isActive('/app/flight')" [src]="imagePieces[1]" width="45" height="45" alt=""><br>
      </span>

        <span  class="bold" [ngClass]="{'active' :isActive('/app/flight')}" style="padding: 0 8px 0 8px;">
          <img *ngIf="!isActive('/app/flightlist')&&!isActive('/app/flightList')&&isActive('/app/hotellist')&&!isActive('/app/flight-intl-list')" [src]="imagePieces[0]" width="30" height="30" alt="">

          <img *ngIf="isActive('/app/flightlist')&&!isActive('/app/hotellist')||isActive('/app/flightList')&&!isActive('/app/hotellist')||isActive('/app/flight-intl-list')&&!isActive('/app/hotellist')" [src]="imagePieces[1]" width="30" height="30" alt="">
         Flight
      </span>
    </div> 
    <div class=" col-md-3" (click)="OnClickHotel()"   style="cursor:pointer">  
         <span *ngIf="!isActive('/app/hotellist')&&!isActive('/app/flightlist')&&!isActive('/app/flightList')&&!isActive('/app/flight-intl-list')">

      <img *ngIf="!isActive('/app/hotel')" [src]="imagePieces[10]" width="45" height="45" alt="">
      <img *ngIf="isActive('/app/hotel')" [src]="imagePieces[11]" width="45" height="45" alt=""><br>
    </span>
    <img *ngIf="!isActive('/app/hotellist')&&isActive('/app/flightlist')||!isActive('/app/hotellist')&&isActive('/app/flightList')||!isActive('/app/hotellist')&&isActive('/app/flight-intl-list')" [src]="imagePieces[10]" width="30" height="30" alt="">

    <img *ngIf="isActive('/app/hotellist')&&!isActive('/app/flightlist')&&!isActive('/app/flightList')&&!isActive('/app/flight-intl-list')" [src]="imagePieces[11]" width="30" height="30" alt="">

     <span class="bold" [ngClass]="{'active' :isActive('/app/hotel')}" style="padding: 0 8px 0 8px;">
      Hotel</span>
    
    </div> 
    <!-- (click)="OnClickCab()" -->
    <div class=" col-md-3"    style="cursor:pointer">  
      <span *ngIf="!isActive('/app/hotellist')&&!isActive('/app/flightlist')&&!isActive('/app/flightList')&&!isActive('/app/flight-intl-list')">

   <img *ngIf="!isActive('/app/cabs')" [src]="imagePieces[2]" width="45" height="45" alt="">
   <img *ngIf="isActive('/app/cabs')" [src]="imagePieces[3]" width="45" height="45" alt=""><br>
 </span>
 <img *ngIf="isActive('/app/flightList')||isActive('/app/flightlist')||isActive('/app/hotellist')||isActive('/app/flight-intl-list')" [src]="imagePieces[2]" width="30" height="30" alt="">

  <span class="bold" [ngClass]="{'active' :isActive('/app/cabs')}" style="padding: 0 8px 0 8px;">
   Cabs</span>
 
 </div> 
 <div class=" col-md-3"    style="cursor:pointer">  
  <span *ngIf="!isActive('/app/flightList')&&!isActive('/app/hotellist')&&!isActive('/app/flightlist')&&!isActive('/app/flight-intl-list')">

<img *ngIf="!isActive('/app/buses')" [src]="imagePieces[40]" width="45" height="45" alt="">
<img *ngIf="isActive('/app/buses')" [src]="imagePieces[41]" width="45" height="45" alt=""><br>
</span>
<img *ngIf="isActive('/app/flightList')||isActive('/app/flightlist')||isActive('/app/hotellist')||isActive('/app/flight-intl-list')" [src]="imagePieces[40]" width="30" height="30" alt="">

<span class="bold" [ngClass]="{'active' :isActive('/app/buses')}" style="padding: 0 8px 0 8px;">
Buses</span>

</div> 
</div>
<div class="row col-md-5">
<div class=" col-md-4"    style="cursor:pointer">  
  <span *ngIf="!isActive('/app/flightList')&&!isActive('/app/hotellist')&&!isActive('/app/flightlist')&&!isActive('/app/flight-intl-list')">

<img *ngIf="!isActive('/app/trains')" [src]="imagePieces[30]" width="45" height="45" alt="">
<img *ngIf="isActive('/app/trains')" [src]="imagePieces[31]" width="45" height="45" alt=""><br>
</span>
<img *ngIf="isActive('/app/flightList')||isActive('/app/flightlist')||isActive('/app/hotellist')||isActive('/app/flight-intl-list')" [src]="imagePieces[30]" width="30" height="30" alt="">

<span class="bold" [ngClass]="{'active' :isActive('/app/trains')}" style="padding: 0 8px 0 8px;">
Trains</span>

</div> 
<div (click)="OnClickInsurance()" class=" col-md-4"    style="cursor:pointer">  
  <span *ngIf="!isActive('/app/flightList')&&!isActive('/app/hotellist')&&!isActive('/app/flightlist')&&!isActive('/app/flight-intl-list')">

<img *ngIf="!isActive('/app/insurance')" [src]="imagePieces[34]" width="45" height="45" alt="">
<img *ngIf="isActive('/app/insurance')" [src]="imagePieces[35]" width="45" height="45" alt=""><br>
</span>
<img *ngIf="isActive('/app/flightList')||isActive('/app/flightlist')||isActive('/app/hotellist')||isActive('/app/flight-intl-list')" [src]="imagePieces[34]" width="30" height="30" alt="">

<span class="bold" [ngClass]="{'active' :isActive('/app/insurance')}" style="padding: 0 8px 0 8px;">
  Insurance</span>

</div> 
<!-- <div class=" col-md-4"   style="cursor:pointer">  
  <span *ngIf="!isActive('/app/hotellist')&&!isActive('/app/flightlist')">

<img *ngIf="!isActive('/app/giftCards')" [src]="imagePieces[4]" width="45" height="45" alt="">
<img *ngIf="isActive('/app/giftCards')" [src]="imagePieces[5]" width="45" height="45" alt=""><br>
</span>
<img *ngIf="isActive('/app/flightlist')||isActive('/app/hotellist')" [src]="imagePieces[4]"width="30" height="30" alt="">

<span class="bold" [ngClass]="{'active' :isActive('/app/giftCards')}" style="padding: 0 8px 0 8px;">
Giftcards</span>

</div>  -->
</div>
    <!-- <div class="link " ><ul><li><a    routerLink="/app/flight" ><mat-icon style="margin-right:10px; padding-top: 2px;" >departure_board</mat-icon>Bus</a></li></ul></div>  -->
  </div>

    <!-- <div class="links" >
    </div> -->